import { Component, Watch, Vue } from 'vue-property-decorator';
import { RifoTamplateStates } from '../../services/CommonStates/States/template.state';
import HomeDefault from './Templates/Default/default.vue';
import HomeDemo from './Templates/Demo/demo.vue';
import HomeEpic from './Templates/Epic/epic.home.vue';

@Component({
    components: {
        'default': HomeDefault,
        'demo': HomeDemo,
        'epic': HomeEpic,
    }
})
export default class Home extends Vue {
    public title: string = 'Home';

    public template: RifoTamplateStates.ERifoTemplates = RifoTamplateStates.ERifoTemplates.Default;

    @Watch('$store.state.rifoTemplate.template', { immediate: true, deep: true })
    public onTemplateChanged(val: any, oldVal: any) {
        // console.log(val);
        this.template = val;
    }

    public handleSwitchDemo() {
        if (this.template === RifoTamplateStates.ERifoTemplates.Default) {
            this.$store.commit('setTemplate', RifoTamplateStates.ERifoTemplates.Epic);
        } else {
            this.$store.commit('setTemplate', RifoTamplateStates.ERifoTemplates.Default);
        }
    }
    public created() {
    }
}
